import { makeStyles } from '@material-ui/core';

export const useStyles = makeStyles(() => ({
  colorPicker: {
    margin: '12px auto',
    boxShadow: '2px 2px 5px 0px rgba(0,0,0,0.5) !important',
    position: 'absolute!important' as 'absolute',
    zIndex: 2,
    left: 0,
    right: 0
  }
}));
